import { useMemo } from 'react';
import { cn } from './format';
import { encodeQr, type QrEcc } from './qr';

const QUIET_ZONE = 4;

/** Koyu modül dizilerini tek bir SVG path'ine çevirir (satır başına yatay şeritler). */
export function qrPath(modules: readonly (readonly boolean[])[], offset = QUIET_ZONE): string {
  let d = '';
  modules.forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      if (!row[x]) {
        x++;
        continue;
      }
      const start = x;
      while (x < row.length && row[x]) x++;
      const len = x - start;
      d += `M${start + offset} ${y + offset}h${len}v1h-${len}z`;
    }
  });
  return d;
}

export interface QrCodeProps {
  value: string;
  /** Piksel cinsinden kenar uzunluğu. */
  size?: number;
  label?: string;
  ecc?: QrEcc;
  className?: string;
}

/**
 * Erişilebilir SVG QR kodu. Tema ne olursa olsun beyaz zemin + siyah modül kullanılır;
 * aksi halde koyu temada telefon kameraları kodu okuyamayabilir.
 */
export function QrCode({ value, size = 192, label = 'QR kodu', ecc = 'M', className }: QrCodeProps) {
  const { dim, d } = useMemo(() => {
    const qr = encodeQr(value, ecc);
    return { dim: qr.size + QUIET_ZONE * 2, d: qrPath(qr.modules) };
  }, [value, ecc]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${dim} ${dim}`}
      shapeRendering="crispEdges"
      className={cn('block h-auto max-w-full', className)}
      style={{ backgroundColor: '#ffffff' }}
    >
      <title>{label}</title>
      <rect width={dim} height={dim} fill="#ffffff" />
      <path d={d} fill="#000000" />
    </svg>
  );
}
